import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inner_link = _resolveComponent("inner-link")!

  return (_openBlock(), _createBlock(_TransitionGroup, {
    name: "fade-transform",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iframeViews, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_inner_link, {
          key: item.path,
          iframeId: 'iframe' + index,
          src: _ctx.iframeUrl(item.meta.link, item.query)
        }, null, 8, ["iframeId", "src"])), [
          [_vShow, _ctx.route.path === item.path]
        ])
      }), 128))
    ]),
    _: 1
  }))
}